import { TypedDocumentNode, gql } from '@apollo/client';

import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import {
  AddAuctionReminderMutation,
  AddAuctionReminderMutationVariables,
} from './__generated__/useAddReminder.graphql';

const ADD_REMINDER = gql`
  mutation AddAuctionReminderMutation(
    $input: addAuctionReminderInput!
    $sport: Sport!
  ) {
    addAuctionReminder(input: $input) {
      auction {
        id
        myReminder {
          id
          enabled
        }
      }
      currentUser {
        slug
        involvedLiveTokenAuctions(first: 10, sport: [$sport]) {
          nodes {
            id
          }
        }
      }
      errors {
        code
        message
      }
    }
  }
` as TypedDocumentNode<
  AddAuctionReminderMutation,
  AddAuctionReminderMutationVariables
>;

type Props = {
  auction: {
    id: string;
  };
};

export const useAddReminder = () => {
  const { sport } = useSportContext();
  const [addReminder, { loading }] = useMutation(ADD_REMINDER, {
    showErrorsWithSnackNotification: true,
  });

  return {
    addReminder: async ({ auction }: Props) => {
      const { data } = await addReminder({
        variables: { input: { tokenAuctionId: auction.id }, sport },
      });
      return data?.addAuctionReminder?.auction?.myReminder;
    },
    loading,
  };
};
